export default __webpack_public_path__ + "static/media/06.24.25 Minutes Spcl Mtg.20ae19c1.pdf";